/** Site logo – favicon, navbar, footer, og:image. Kaynak: https://ibb.co/84SDf2cT */
export const SITE_LOGO_URL = "https://i.ibb.co/84SDf2cT/84SDf2cT.png";
